{
  "Back": "Retour",
  "Invoice": "Facture",
  "Payment Due": "Paiement dû",
  "Paid": "Payé",
  "Download PDF": "Télécharger le PDF",
  "Pay Invoice": "Payer la Facture",
  "Invoice Date": "Date de la Facture",
  "Due Date": "Date d'échéance",
  "Auto-Pay On": "Paiement Automatique Activé",
  "Auto-Pay Off": "Auto-Pay Désactivé",
  "Invoice Total": "Total de la facture",
  "Balance due": "Solde dû",
  "Bill To": "Facturer à",
  "Account Number": "Numéro de Compte",
  "Account Balance": "Solde du Compte",
  "Bill From": "Facture De",
  "Check payment instructions": "Vérifiez les instructions de paiement",
  "If paying via check": "Si vous payez par chèque, libellez-le à l'ordre de {{recipient}}, incluez votre numéro de compte ({{accountNumber}}) et l'ID de l'emplacement ({{locationId}}) dans la section 'mémo', et joignez une copie de cette facture avec votre chèque :",
  "USPS": "Si vous envoyez par USPS standard, envoyez à Industrious Office, P.O. Box 780441, Philadelphia PA 19178-0441.",
  "courier": "Si vous envoyez par service de nuit ou par coursier, envoyez à Wells Fargo Lockbox Services, Industrious Office, Lockbox - 780441, MAC: Y1372-045, 401 Market Street, Philadelphie PA 19106.",
  "Payment is due on the invoice due date": "Le paiement est dû à la date d'échéance de la facture. Des frais de retard de 10% seront appliqués à tous les soldes ouverts qui dépassent de plus de 5 jours leur date d'échéance. Si vous êtes déjà inscrit au prélèvement automatique ACH ou à la carte de crédit, Industrious débitera votre compte à la date d'échéance de la facture et aucune action n'est requise.",
  "To the extent applicable": "Dans la mesure applicable aux services fournis ou à la licence qui vous est accordée et dans toute la mesure où les responsabilités d'Industrious sont limitées, les Conditions d'Utilisation et la Politique de Confidentialité d'Industrious, situées à",
  "incorporated": "sont incorporés par référence et régissent et contrôlent notre accord comme si vous étiez un membre et un licencié de l'espace de bureau Industrious. Le paiement constitue l'acceptation de tous les termes de cette facture par vous.",
  "Please contact billing@industriousoffice.com with any questions regarding your invoice.": "Veuillez contacter billing@industriousoffice.com pour toute question concernant votre facture.",
  "MAC": "MAC: Y1372-045, 401 Market Street, Philadelphia PA 19106.",
  "Applied Credit": "Crédit Appliqué",
  "As of {{date}}, this invoice is scheduled for auto-pay.": "À compter du {{date}}, le paiement automatique de cette facture est prévu.",
  "As of {{date}}, this invoice is not scheduled for auto-pay.": "À compter du {{date}}, le paiement automatique de cette facture n'est pas prévu.",
  "Item": "Item",
  "Description": "Description",
  "Service Period": "Période de service",
  "Unit Price": "Prix unitaire",
  "Quantity": "Quantité",
  "Amount": "Montant"
}
